<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalDownloadFiles from '@/components/other_incomes/ModalDownloadFilesComponent.vue';
import ModalFormComponent from '../../components/other_incomes/ModalFormComponent.vue';
import Pagination from 'vue-pagination-2';
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "other_incomes",
	components: {
		ModalFormComponent,
		ModalDownloadFiles,
		Pagination,
		DatePicker,
	},
	data() {
		return {
			loadAll: false,
			incomes: {},
			incomes_p: [],
			incomes_s: [],
			name: '',
			editIncome: true,
			trigger: true,
			init:false,
			search: {
				search: '',
				date: '',
				company_id: '',
				client_id: '',
				// biill_type_id: '',
				// pay_order: '',
				// resident: 0
			},
			order:{
				id:-1,
				name:-1,
				created_at:-1,
				amount:-1,
				date:0,
			},
			page: 1,
			per_page: 10,
			send: false,
			catalogue: new Catalogue(),
			load: false,
			isExpanded: []
		}
	},
	// filters:{
	// 	statusType(status){
	// 		switch(status){
	// 			case "V":
	// 			return "Válido y Conciliado"
	// 			case "P":
	// 			return "Pendiente por Proveedor"
	// 			case "I":
	// 			return "No encontrado en el SAT"
	// 			case "N":
	// 			return "Pendiente de Conciliar"
	// 			default:
	// 			return "Estatus no encontrado";
	// 		}			
	// 	} 
	// },	
	async mounted() {
		this.loadAll = true;

		this.list();
		this.catalogue.get_companies_buildings();
		this.catalogue.get_users_profile(9);
		this.setHeaderTitle('Otros Ingresos');
		this.loadAll = false;

	},
	created() {
		Event.$on("event-load-incomes", () => {
			this.list();
		});
	},
	methods: {
		// shouldShowAuthorizeButton(contract) {
		// 	const userId = this.authUser.id;

		// 	const validator = contract.users_approved.find(v =>
		// 		v.user_id === userId
		// 	);

		// 	return !validator;
		// },
		// approveIncome: function (id) {
		// 	let tit = 'Aprobar pago';
		// 	let txt = 'Seguro que quiere aprobar el pago';

		// 	this.$swal({
		// 		title: tit,
		// 		text: txt,
		// 		icon: 'warning',
		// 		showCancelButton: true,
		// 		confirmButtonColor: '#3085d6',
		// 		cancelButtonColor: '#d33',
		// 		confirmButtonText: 'Ok',
		// 		cancelButtonText: 'Cancelar'
		// 	}).then(async (result) => {
		// 		if (result.isConfirmed) {
		// 			let _endpoint = '/income_validators';
		// 			let form = {
		// 				id: id
		// 			};
		// 			try {
		// 				let response = await request.post(_endpoint, form).then(function (response) { return response; });
		// 				this.list();
		// 				this.successNotification(response.data.message);
		// 			} catch (error) {
		// 				this.errors = await this.errorNotification(error)
		// 			}
		// 		}
		// 	});
		// },
		showData(id) {
			let vm = this;
			let ids = this.isExpanded;
			let position = ids.indexOf(id);
			if (position == -1) {
				vm.isExpanded.push(id);
			} else {
				vm.isExpanded.splice(position, 1);
			}

		},
		isVisible(id) {
			let ids = this.isExpanded;
			return ids.includes(id);
		},
		sumdata() {
			let sum1 = 0;
			if (this.incomes_s.length>0) {
				this.incomes_s.forEach(function (income) {
					sum1 += parseFloat(income.amount) * (income.currency_id!=1?income.exchange_rate:1);
				});
			}

			return sum1
		},
		// downloadFiles() {
		// 	let filter = this.search;
		// 	filter.type = 'income';
		// 	filter.user_logged = this.authUser.id;

		// 	let data = new URLSearchParams(filter).toString();

		// 	let _url = this.globalUrlFiles + '/incomes/download_files?' + data;
		// 	window.open(_url, '_blank');

		// 	// Event.$emit('event-show-downloadFiles', filter);
		// },
		downloadFile(type, id) {
			let url = this.globalUrlFiles + '/incomes/download_file?id=' + id + '&type=' + type;
			window.open(url, '_blank');
		},
		// AddCheck(income = {}) {

		// 	Event.$emit('event-show-addChecksIncome', income);
		// },
		// downloadExcek() {
		// 	let data = new URLSearchParams(this.search).toString();
		// 	let url = this.globalUrlFiles + '/incomes/export?number=' + this.authUser.id + '&' + data;
		// 	window.open(url, '_blank');
		// },
		// cancelIncome(id) {
		// 	let vm = this;
		// 	this.$swal({
		// 		title: 'Motivos de Cancelación',
		// 		input: 'text',
		// 		icon: 'warning',
		// 		inputAttributes: {
		// 			autocapitalize: 'off'
		// 		},
		// 		showCancelButton: true,
		// 		confirmButtonText: 'Guardar',
		// 		showLoaderOnConfirm: true,
		// 		preConfirm: async (message) => {
		// 			let form = {
		// 				id: id,
		// 				message: message,
		// 			};
		// 			let _endpoint = '/cancel_incomes';
		// 			try {
		// 				let { data } = await request.postMedia(_endpoint, form)
		// 				if (data) {
		// 					await vm.successNotification(data.message);
		// 					await vm.list();
		// 				}
		// 			} catch (error) {
		// 				vm.errors = {};
		// 				if (error.response) {
		// 					vm.errors = vm.errorNotification(error);
		// 				}
		// 			}
		// 		},
		// 		allowOutsideClick: () => !this.$swal.isLoading()
		// 	}).then((result) => {
		// 		if (result.isConfirmed) {
		// 			// console.log(result);
		// 		}
		// 	})

		// },
		async newIncome(account = {}, edit = true) {
			this.editIncome = edit;
				Event.$emit('event-show-addIncome', account);
		},
		deleted: function (id) {
			let tit = 'Eliminar ingreso';
			let txt = 'Seguro que quiere eliminar el ingreso?';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/incomes/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response; });
				this.list();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		async changePage(page = 1){
			this.incomes_s=this.incomes_p[page-1];
		},
		async sortPage(name){
			switch(name){
				case 'id':
					this.order.id++;
					if(this.order.id%2==0)
						this.incomes=this.incomes.sort((a,b)=>{
							return a.id - b.id
						});
					else
						this.incomes=this.incomes.sort((a,b)=>{
							return b.id - a.id
						});
					this.order.name=-1;
					this.order.created_at=-1;
					this.order.amount=-1;
					this.order.date=-1;
				break;
				case 'name':
					this.order.name++;
					if(this.order.name%2==0)
						this.incomes=this.incomes.sort((a,b)=>{
							return a.company.name.localeCompare(b.company.name)
						});
					else
						this.incomes=this.incomes.sort((a,b)=>{
							return b.company.name.localeCompare(a.company.name)
						});
					this.order.id=-1;
					this.order.created_at=-1;
					this.order.amount=-1;
					this.order.date=-1;
				break;
				case 'amount':
					this.order.amount++;
					if(this.order.amount%2==0)
						this.incomes=this.incomes.sort((a,b)=>{
							return a.amount- b.amount
						});
					else
						this.incomes=this.incomes.sort((a,b)=>{
							return b.amount- a.amount
						});
					this.order.id=-1;
					this.order.name=-1;
					this.order.date=-1;
					this.order.created_at=-1;
				break;
				case 'date':
					this.order.date++;
					if(this.order.date%2==0)
						this.incomes=this.incomes.sort((a,b)=>{
							return new Date(a.date) - new Date(b.date)
						});
					else
						this.incomes=this.incomes.sort((a,b)=>{
							return new Date(b.date) - new Date(a.date)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.name=-1;
					this.order.created_at=-1;
				break;
				case 'created_at':
					this.order.created_at++;
					if(this.order.created_at%2==0)
						this.incomes=this.incomes.sort((a,b)=>{
							return new Date(a.created_at) - new Date(b.created_at)
						});
					else
						this.incomes=this.incomes.sort((a,b)=>{
							return new Date(b.created_at) - new Date(a.created_at)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.name=-1;
					this.order.date=-1;
				break;
			}
		},
		async list() {
			this.order={
				id:-1,
				name:-1,
				amount:-1,
				date:0,
				created_at:-1,
			};
			this.init=false;
			this.load = true;
			this.incomes=[];
			this.page=1;
			let service = request;
			let search = this.search;
			let _endpoint = '/other_incomes';
			search.search = this.name;
			try {
				let { data } = await service.list(_endpoint, search)
				if (data.data) {
					this.init=this.search.search == '' &&
					(this.search.date == '' || this.search.date[0]==null) &&
					this.search.company_id == '' &&
					this.search.client_id == '';
					this.incomes = data.data;
					this.sortPage('date');
					if(data.dates[0]!=''){
						this.trigger=false;
						this.search.date = data.dates;
					}
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;

			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'incomes': {
			handler: function () {
				if(this.incomes.length>0){
					let vm=this,k=0,j=1;
					this.incomes_p=[];
					this.incomes_p[0]=[];
					this.incomes.forEach(s=>{
						vm.incomes_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.incomes_p[k]=[];
						}
						j++;

					});
					this.incomes_s=this.incomes_p[this.page-1];
				}else{
					this.incomes_p=[];
					this.incomes_s=[];
				}
			},
			deep: true
		},
		'name': {
			handler: function (val) {
				if (val == '') {
					this.list();
				}
			},
			deep: true
		},
		'search': {
			handler: function () {
				if(this.trigger)
					this.list();
				else
					this.trigger=true;
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Lista de Ingresos</h3>
				<div class="card-tools">
					<!-- <button @click="downloadFiles()" class="btn btn-sm btn-outline-secondary mr-1" v-if="authUser.organization_charts_id != 2">
						<i class="fa-solid fa-box-archive"></i> Archivo de facturas
					</button>
					<button @click="downloadExcek()" class="btn btn-sm btn-outline-success mr-1">
						<i class="fa-solid fa-file-excel"></i> Excel
					</button> -->
					<button v-if="!loadAll" @click="newIncome()" v-can="'add_other_income'"
						class="btn btn-sm btn-outline-info">
						<i class="fa fa-plus"></i> Ingreso
					</button>

				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-7 col-lg-8">
						<label>Buscar :</label>
						<input class="form-control" type="search" v-debounce:1s="list" v-model="name">
					</div>
					<div class="col-md-5 col-lg-4">
						<label>Rango de fechas :</label>
						<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
							v-model="search.date"></date-picker>
						<div v-if="init" class="text-danger">Periodo por Defecto</div>
					</div>
					<div class="col-md-4">
						<label>Empresa :</label>
						<select v-model="search.company_id" class="form-control">
							<option value="">Todos</option>
							<option v-for="(company, index) in catalogue.companies_buildings" :key="index"
								:value="company.id"> {{ company.name }}
							</option>
						</select>
					</div>
					<div class="col-md-4">
						<label>Cliente :</label>
						<select v-model="search.client_id" class="form-control">
							<option value="">Todos</option>
							<option v-for="(client, index) in catalogue.users_profile" :key="index"
								:value="client.id"> {{ client.name }} {{ client.last_name }}
							</option>
						</select>
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-md-6">
						<!-- <ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item" v-can="'view_created'">
								<a class="nav-link active" @click="search.paid = 0, search.authorized = 1" data-toggle="pill" role="tab"
									aria-selected="true" v-if="this.authUser.profile.permissions.some(permission => permission.permission=='view_created')">Repartos</a>
								<a class="nav-link" @click="search.paid = 0, search.authorized = 1" data-toggle="pill" role="tab"
									aria-selected="false" v-else>Repartos</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.paid = 0, search.authorized = 0" data-toggle="pill" role="tab"
									aria-selected="false" v-if="this.authUser.profile.permissions.some(permission => permission.permission=='view_created')">Aprobados</a>
								<a class="nav-link active" @click="search.paid = 0, search.authorized = 0" data-toggle="pill" role="tab"
									aria-selected="true"  v-else>Aprobados</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.authorized = 0, search.paid = 1" data-toggle="pill" role="tab"
									aria-selected="false">Pagados</a>
							</li>
						</ul> -->
					</div>
					<div class="col-md-6">
						<!-- <button class="btn btn-outline-success btn-sm mr-2" v-can="'export_share'"
							v-if="!(search.authorized==0 && search.paid==0)"
							@click="exportData()">
							<i class="fa fa-file-excel"></i> Exportar
						</button> -->
						<label>
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item">
									<label class="nav-link">Resultados por P&aacute;gina:</label>
								</li>
								<li class="nav-item">
									<a class="nav-link active" @click="per_page = 10" data-toggle="pill" aria-selected="true">10</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="per_page = 20" data-toggle="pill" aria-selected="false">20</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="per_page = 50" data-toggle="pill" aria-selected="false">50</a>
								</li>
							</ul>
						</label>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead class="sticky-top top-0">
							<tr>
								<th>ID
									<button class="btn btn-xs" @click.prevent="sortPage('id')">
										<i class="fa" :class="order.id==-1?'fa-minus':(order.id%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th style="width: 50%;">Datos
									<button class="btn btn-xs" @click.prevent="sortPage('name')">
										<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Fecha de creación
									<button class="btn btn-xs" @click.prevent="sortPage('created_at')">
										<i class="fa" :class="order.created_at==-1?'fa-minus':(order.created_at%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Fecha de factura
									<button class="btn btn-xs" @click.prevent="sortPage('date')">
										<i class="fa" :class="order.date==-1?'fa-minus':(order.date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th style="width: 140px;">Monto
									<button class="btn btn-xs" @click.prevent="sortPage('amount')">
										<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="9">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>
								</td>
							</tr>
						</tbody>
						<tbody v-else-if="incomes_s.length > 0">
							<tr  v-for="(income, index) in incomes_s" :key="index">
								<td>
									{{ income.id }}
									<br>
									<button class="btn btn-info btn-sm text-sm" style="padding: 2px 5px;"
										@click="showData(income.id)">
										<i v-if="isVisible(income.id)" class="fa-solid fa-minus"></i>
										<i v-else class="fa-solid fa-plus"></i>
									</button>
								</td>
								<td class="text-left">
									<!-- Proveedor -->
									<div>

										<strong>Cliente:</strong><br>
										<span v-if="income.client">{{ income.client.name }} {{ income.client.last_name }}</span>
										<span v-else> Sin cliente</span>
										<br>
									</div>
									<br>
									<!-- Concepto -->
									<transition name="fade">

										<div v-if="isVisible(income.id)">
											<strong>Concepto:</strong>
											{{ income.name }}
											<br>
											<!-- Empresa  -->
											<strong>Empresa:</strong>
											<span v-if="income.company">{{ income.company.name }}</span>
											<span v-else> Sin empresa</span>
											<br>
											<!-- Tipo  -->
											<strong>Tipo de pago:</strong>
											<span v-if="income.payment">{{ income.payment.name }}</span>
											<span v-else> Sin tipo de pago</span>
											<br>
											<!-- Cuenta Bancaria -->
											<strong class="mt-3 mb-n3 d-block">Cuenta Bancaria:</strong><br>
											<span v-if="income.bank_account_company">
												{{ income.bank_account_company.bank.name }} -
												{{ income.bank_account_company.number }} |
												<!-- <a class="btn btn-info btn-sm" target="_blank"
													v-if="income.bank_account_comany.file"
													:href="`${globalUrlFiles}${income.bank_account_company.file}`">
													<i class="fa-regular fa-file-pdf"></i> Ver caratula de banco
												</a>
												<small v-else class="btn_now badge badge-secondary"> Sin caratula de
													banco</small> -->
											</span>
											<span v-else> S/D </span>
											<br>
											<!-- Folio -->
											<strong>Folio:</strong><br>
											<span v-if="income.folio">{{ income.folio }} </span>
											<span v-else> S/F </span>
											<br>
											<!-- Moneda -->
											<strong>Moneda:</strong><br>
											<span v-if="income.currency">{{ income.currency.name }} </span>
											<span v-else> S/M </span>
											<br>
											<span v-if="income.currency_id==2">
												<strong>Tipo de Cambio : </strong>
												<span> {{ income.exchange_rate | toCurrency }}</span>
												<br>
											</span>
											<br>
										</div>
									</transition>

									<!-- Botones -->
									<a :href="`${globalUrlFiles}${income.file}`" v-if="income.file" target="_blank"
										class="btn m-1 btn-outline-secondary btn-sm">
										<i class="fas fa-file-pdf "> </i> Archivo PDF
									</a>
									<button v-if="income.xml" class="btn m-1 btn-outline-secondary btn-sm"
										@click="downloadFile('xml', income.id)">
										<i class="fas fa-file "> </i> Archivo XML
									</button>
									<button @click="newIncome(income)" v-can="'edit_other_income'"
										class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-edit "> </i> Editar
									</button>
									<button @click="newIncome(income, false)"
										class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-eye "> </i> Ver más
									</button>
									<!-- <button type="button" v-if="!income.check" @click="cancelIncome(income.id)"
										v-can="'deleted_other_income'" class="btn m-1 btn-outline-danger btn btn-sm ">
										<i class="fa-solid fa-xmark"></i> Cancelar Factura
									</button> -->
								</td>
								<td>{{ income.created_at | toDateTime }}</td>
								<td>{{ income.date | toDateTime }}</td>

								<td class="text-right" v-if="income.currency_id==2">
									{{ income.amount * income.exchange_rate | toCurrency }}
									<br>
									{{ income.amount | toCurrency }} USD
								</td>
								<td class="text-right" v-else>
									{{ income.amount | toCurrency }}
								</td>
								<td>
									<button type="button" @click="deleted(income.id)"
										v-can="'delete_other_income'" class="btn m-1 btn-outline-danger btn btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>
									<!-- <button type="button" @click="approveIncome(income.id)"
										v-if="shouldShowAuthorizeButton(income) && authUser.organization_charts_id != 2"
										class="btn-outline-warning btn m-1 btn-sm ">
										<i class="fa fa-check"></i> Vo.Bo.
									</button> -->

								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="9">Sin resultados.</td>
							</tr>
						</tbody>
						<tfoot v-if="incomes_s.length > 0 && load == false">
							<tr class="table-secondary">
								<td colspan="4">
									Total :
								</td>
								<td class="text-right">
									{{ sumdata() | toCurrency }}
								</td>
								<td></td>
							</tr>
						</tfoot>
					</table>
					<pagination v-if="incomes_s" v-model="page" :records="incomes?incomes.length:0" :per-page="per_page"
						@paginate="changePage" />
				</div>
			</div>
		</div>
		<ModalFormComponent :prop_edit="editIncome" />
		<ModalDownloadFiles />
	</div>
</template>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
	{
	opacity: 0;
}

.semaforo{
	height: 25px;
	width: 25px;
	border: black;
}

</style>
